function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "cbbfc-logo--white_svg__a",
  d: "M.16.144h45.33v65.089H.16z"
}), /*#__PURE__*/React.createElement("path", {
  id: "cbbfc-logo--white_svg__c",
  d: "M.75.144h45.33v65.089H.75z"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M157.388 19.303l8.988-.004c1.133 0 1.506 1.114 1.069 1.852l-3.726 6.455c-.332.573-.68.926-1.604.926h-4.727l-.017 35.037c0 .682-.551 1.233-1.234 1.233h-7.775c-.68 0-1.233-.552-1.233-1.234V28.532h-3.807a1.234 1.234 0 01-1.235-1.234v-6.76c0-.682.552-1.235 1.235-1.235h3.807v-1.59c0-9.285 7.484-16.967 16.77-16.917.785.005 1.56.049 2.313.172 1.024.168 1.594.913 1.594 1.835v5.565c0 .75-.583 1.334-1.405 1.22a7.956 7.956 0 00-9.013 7.841v1.874z",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(94.395 .623)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "cbbfc-logo--white_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#cbbfc-logo--white_svg__a"
})), /*#__PURE__*/React.createElement("path", {
  d: "M36.653 42.172c0-7.637-6.19-13.828-13.828-13.828-7.638 0-13.828 6.19-13.828 13.828 0 7.637 6.19 13.827 13.828 13.827 7.637 0 13.828-6.19 13.828-13.827m8.837 0c0 12.736-10.147 23.06-22.665 23.06a22.29 22.29 0 01-12.407-3.765v1.478c0 .682-.553 1.234-1.234 1.234h-7.79A1.234 1.234 0 01.16 62.945V10.379c0-1.228.425-2.302 1.356-3.273L8.05.573c.873-.875 2.369-.345 2.369.982v21.32a22.29 22.29 0 0112.407-3.763c12.518 0 22.665 10.324 22.665 23.06",
  fill: "#FFF",
  mask: "url(#cbbfc-logo--white_svg__b)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(42.977 .623)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "cbbfc-logo--white_svg__d",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#cbbfc-logo--white_svg__c"
})), /*#__PURE__*/React.createElement("path", {
  d: "M37.243 42.172c0-7.637-6.19-13.828-13.828-13.828-7.637 0-13.828 6.19-13.828 13.828 0 7.637 6.19 13.827 13.828 13.827 7.637 0 13.828-6.19 13.828-13.827m8.837 0c0 12.736-10.147 23.06-22.665 23.06a22.286 22.286 0 01-12.407-3.765v1.478c0 .682-.552 1.234-1.234 1.234h-7.79A1.234 1.234 0 01.75 62.945V10.379c0-1.228.425-2.302 1.355-3.273L8.638.573c.874-.875 2.37-.345 2.37.982v21.32a22.285 22.285 0 0112.407-3.763c12.518 0 22.665 10.324 22.665 23.06",
  fill: "#FFF",
  mask: "url(#cbbfc-logo--white_svg__d)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M204.406 57.451l-5.553-3.206a1.852 1.852 0 00-1.979.083 12.961 12.961 0 01-7.363 2.295c-7.637 0-13.828-6.19-13.828-13.828 0-7.637 6.191-13.828 13.828-13.828 2.722 0 5.252.845 7.363 2.295a1.86 1.86 0 001.979.084l5.553-3.207c1.02-.558 1.082-1.726.276-2.472-3.858-3.574-9.336-5.933-15.171-5.933-12.517 0-22.666 10.325-22.666 23.061 0 12.735 10.149 23.06 22.666 23.06 5.835 0 11.155-2.246 15.17-5.933a1.543 1.543 0 00-.275-2.47",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.561 57.451l-5.553-3.206a1.852 1.852 0 00-1.979.083 12.961 12.961 0 01-7.363 2.295c-7.638 0-13.829-6.19-13.829-13.828 0-7.637 6.191-13.828 13.829-13.828 2.722 0 5.252.845 7.363 2.295a1.86 1.86 0 001.979.084l5.553-3.207c1.018-.558 1.081-1.726.275-2.472-3.858-3.574-9.335-5.933-15.17-5.933C10.149 19.734 0 30.06 0 42.795s10.149 23.06 22.666 23.06c5.835 0 11.154-2.246 15.17-5.933a1.543 1.543 0 00-.275-2.47",
  fill: "#FBAD00"
}));

function SvgCbbfcLogoWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 206 66"
  }, props), _ref, _ref2);
}

export default SvgCbbfcLogoWhite;